import React from "react";
import { UIPlugin } from "@uppy/core";
import { h } from "preact";
import GooglePicker from "./GooglePicker";
import * as ReactDOM from "react-dom";
 
export class GooglePickerPlugin extends UIPlugin {
  root;
  user;
  tenant;
  itemId;
  options;
  files;
  opts;
  container;
  singleFile = false;
  doRender = false;
  title;
  icon;

  constructor(uppy, opts) {
    if (!opts) {
      return;
    }
    const { user, tenant, itemId, singleFile, options } = opts;
    super(uppy, opts);
    this.type = "acquirer";
    this.id = (this.opts && this.opts.id) || "GooglePickerPlugin";
    this.user = user;
    this.title = "Google Drive";
    this.tenant = tenant;
    this.itemId = itemId;
    this.singleFile = singleFile;
    this.onSelectFiles = this.onSelectFiles.bind(this);

    this.options = options;
    this.icon = () =>
      h(
        "svg",
        {
          "aria-hidden": "true",
          focusable: "false",
          width: "32",
          height: "32",
          viewBox: "0 0 32 32",
        },
        h(
          "g",
          { fillRule: "nonzero", fill: "none" },
          h("path", {
            d: "M6.663 22.284l.97 1.62c.202.34.492.609.832.804l3.465-5.798H5c0 .378.1.755.302 1.096l1.361 2.278z",
            fill: "#0066DA",
          }),
          h("path", {
            d: "M16 12.09l-3.465-5.798c-.34.195-.63.463-.832.804l-6.4 10.718A2.15 2.15 0 005 18.91h6.93L16 12.09z",
            fill: "#00AC47",
          }),
          h("path", {
            d: "M23.535 24.708c.34-.195.63-.463.832-.804l.403-.67 1.928-3.228c.201-.34.302-.718.302-1.096h-6.93l1.474 2.802 1.991 2.996z",
            fill: "#EA4335",
          }),
          h("path", {
            d: "M16 12.09l3.465-5.798A2.274 2.274 0 0018.331 6h-4.662c-.403 0-.794.11-1.134.292L16 12.09z",
            fill: "#00832D",
          }),
          h("path", {
            d: "M20.07 18.91h-8.14l-3.465 5.798c.34.195.73.292 1.134.292h12.802c.403 0 .794-.11 1.134-.292L20.07 18.91z",
            fill: "#2684FC",
          }),
          h("path", {
            d: "M23.497 12.455l-3.2-5.359a2.252 2.252 0 00-.832-.804L16 12.09l4.07 6.82h6.917c0-.377-.1-.755-.302-1.096l-3.188-5.359z",
            fill: "#FFBA00",
          })
        )
      );
  }

  install() {
    if (!this.opts) {
      return;
    }
    const { target } = this.opts;
    if (target) {
      this.mount(target, this);
    }

    this.uppy.on("dashboard:close-panel", () => {
      this.root = null;
    });
    this.uppy.on("dashboard:show-panel", () => {
      this.doRender = true;
    });
  }

  uninstall() {
    this.unmount();
  }

  async onSelectFiles(files, accessToken) {
    this.files = files;

    this.options.accessToken = accessToken;
    this.options.tokenSource = "googleDrive";
    this.uppy.addFiles(files);
  }

  render() {
    return h("div", {
      className: "uppy-Container flex-1 h-full",
      id: this.id,
      ref: (container) => {
        if (container) {
          this.container = container;

          if (!this.root && this.doRender) {
            this.root = "";

            ReactDOM.render(
              <GooglePicker onSelectFiles={this.onSelectFiles} singleFile={this.singleFile} />,
              this.container
            );
            this.doRender = false;
          }
        }
      },
    });
  }
}
